"use client";

import { useT } from "@/lib/i18n/I18nProvider";

/**
 * Full-width home banner. Uses &lt;object&gt; so SMIL pili animation runs
 * (many browsers freeze SMIL when SVG is loaded via &lt;img&gt;).
 */
export function HomeHeroBanner() {
  const t = useT();
  const alt = t("home.heroAlt");
  return (
    <div
      style={{
        width: "100%",
        aspectRatio: "1000 / 150",
        borderRadius: 10,
        overflow: "hidden",
        border: "1px solid #d9e2ec",
        background: "#eef2f5",
        marginBottom: 16,
        lineHeight: 0,
      }}
    >
      <object
        type="image/svg+xml"
        data="/home/phage-bacteria-hero.svg"
        aria-label={alt}
        title={alt}
        style={{
          width: "100%",
          height: "100%",
          display: "block",
          border: 0,
          pointerEvents: "none",
        }}
      >
        {/* eslint-disable-next-line @next/next/no-img-element -- SVG fallback when object is blocked */}
        <img
          src="/home/phage-bacteria-hero.svg"
          alt={alt}
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
      </object>
    </div>
  );
}
